module.exports = __webpack_public_path__ + "media/images/btn_notify_me-103ec8e444d1938f2030dbc1702f3b79.gif";